// 更新页面的参数
export const UPDATE_PAGE_INFO = 'UPDATE_PAGE_INFO'
// 更新用户信息, 设置来源，来自支付宝/小程序/微信
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'



// WEBPACK FOOTER //
// ./src/store/global/mutations_types.js